import classNames from 'classnames'
import { forwardRef, type HTMLAttributes } from 'react'

import style from './CenteredBlock.module.scss'

interface IProps extends HTMLAttributes<HTMLDivElement> {}

const CenteredBlock = forwardRef<HTMLDivElement, IProps>((props, ref) => {
    const { children, className, ...rest } = props
    const cn = classNames(style.container, className)
    return (
        <div ref={ref} className={cn} {...rest}>
            {children}
        </div>
    )
})

CenteredBlock.displayName = 'CenteredBlock'

export default CenteredBlock
